import {IconNight, IconSun} from '@flixbus/honeycomb-icons-react';
import {DriverCostFieldConfig} from '@/components/DriverCosts/DriverCostsTable/DriverCostsTable.types';
import {UnitsSystem} from '@/Pages/Common/LocalUnits/types';
import {Country} from '@/Pages/Countries/store/types';

export const getRegionalCostsDriverCostTableConfig = (
  country: Country,
  localUnits: UnitsSystem
): DriverCostFieldConfig[] => {
  return [
    {
      name: `Driver salary - Weekdays`,
      unit: `${country.currency}/h`,
      key: 'daytimeWeekdaysWorkingHourCost',
      icon: IconSun
    },
    {
      name: `Driver salary - Weeknights`,
      unit: `${country.currency}/h`,
      key: 'nighttimeWeekdaysWorkingHourCost',
      icon: IconNight
    },
    {
      name: `Driver salary - Weekend days`,
      unit: `${country.currency}/h`,
      key: 'daytimeWeekendsWorkingHourCost',
      icon: IconSun
    },
    {
      name: `Driver salary - Weekend nights`,
      unit: `${country.currency}/h`,
      key: 'nighttimeWeekendsWorkingHourCost',
      icon: IconNight
    },
    {
      name: 'Driver change cost',
      unit: `${country.currency}/${localUnits.distanceAbbreviation}`,
      key: 'replacementCostPerKm',
      integerDigitsCount: 7
    },
    {
      name: 'Driver change cost',
      unit: `${country.currency}/h`,
      key: 'replacementCostPerHr'
    },
    {
      name: 'Default accommodation cost',
      unit: `${country.currency}/night`,
      key: 'accommodationCostPerNight'
    },
    {
      name: 'Total daily allowance',
      unit: `${country.currency}/op. day`,
      key: 'dailyAllowance'
    },
    {
      name: 'Empty driving defaults',
      unit: `${localUnits.distanceAbbreviation}/op. day`,
      key: 'prefilledEmptyDistance'
    },
    {
      name: 'Empty driving defaults',
      unit: `h/op. day`,
      key: 'prefilledEmptyHr'
    }
  ];
};
